__webpack_require__.p = "/TerminalTeacher_TS/";